import http from "./http";

// O nginx de produção já publica a API de e-mail em `/api/quartix/*` (ele
// reescreve o prefixo fora antes do proxy_pass para a porta 8889). Em
// desenvolvimento o mesmo prefixo é redirecionado pelo devServer do
// vue.config.js. Por isso o caminho aqui é relativo: o mesmo código serve os
// dois ambientes, e trocar de host é mexer no proxy, não no bundle.
// `VUE_APP_QUARTIX_API_URL` existe só para apontar para outra máquina sem
// tocar em nenhum dos dois proxies.
export const BASE_URL = process.env.VUE_APP_QUARTIX_API_URL || "/api/quartix";

// O modelo do FastAPI declara `data: dict[str, str]`: valor que não for string
// derruba a requisição com 422 antes de chegar ao corpo do endpoint. Campo
// vazio simplesmente não entra no envelope.
function toStringMap(fields) {
  return Object.entries(fields).reduce((acc, [key, value]) => {
    if (value === null || value === undefined) return acc;
    const text = String(value).trim();
    if (text) acc[key] = text;
    return acc;
  }, {});
}

// Envelope único dos alertas da API de e-mail (`/request_demo`, `/login`): os
// dois endpoints recebem o mesmo `{ token, data }` e respondem o mesmo JSON.
export async function postAlert(path, fields, token = null) {
  const { data } = await http.post(`${BASE_URL}/${path}`, {
    token,
    data: toStringMap(fields),
  });

  // Exige o `success: true` em vez de só recusar o `success: false`: o
  // endpoint responde 200 com `{"success": false, ...}` quando o envio falha,
  // e um 200 que não é o JSON dele também não é sucesso — sem o proxy ligado,
  // o historyApiFallback devolve o index.html com status 200 e o axios não
  // reclama.
  if (!data || data.success !== true) {
    throw new Error((data && data.error) || `${path} failed`);
  }
  return data;
}

export default postAlert;
